function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, forwardRef } from "react";
import { Button } from "sprout-ui-dom/dist/Button";
import { themeGet } from "sprout-ui-theme";
import { useRouteMatch, NavLink } from "react-router-dom";
import { scrollTop } from "dom-helpers";
import scrollIntoView from "scroll-into-view-if-needed";
import styled from "styled-components";
const AppBarButton = styled(Button)`
  &.active {
    color: ${themeGet("colors.blue.500")};
  }
`;
const AppBarAppDesktopButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { url , children , onClick , onMouseEnter  } = props, rest = _objectWithoutProperties(props, [
        "url",
        "children",
        "onClick",
        "onMouseEnter"
    ]);
    const match = !!useRouteMatch({
        exact: true,
        path: url
    });
    const as = _objectSpread({}, url && {
        as: NavLink,
        to: url
    });
    const handleClick = useCallback(()=>{
        if (onClick) onClick();
        if (match && scrollTop(document.documentElement) > 0) scrollIntoView(document.body, {
            block: "start",
            behavior: "smooth"
        });
    }, [
        match,
        onClick
    ]);
    return /*#__PURE__*/ _jsx(AppBarButton, _objectSpread({
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        ref: ref,
        variant: "circle"
    }, rest, as, {
        children: typeof children === "function" ? children(match) : children
    }));
});
export default AppBarAppDesktopButton;
